<template>
  <div
    class="flex h-12 items-center bg-gpx_gray-900 pl-6 pr-4 md:pl-12 md:pr-6"
  >
    <slot />
  </div>
</template>
